import { cx } from '@linaria/core';

import LoaderIcon from '~public/assets/icons/buttonLoader.svg';
import { SmartElement } from '~shared/ui/atoms/Buttons/SmartElement';
import type { SmartElementProps } from '~shared/ui/atoms/Buttons/SmartElement/types';

import { Loader, styledButton, styledButtonBaseFullWidth } from './styles';
import type { ButtonBaseProps } from './types';

export const ButtonBase = ({
	children,
	borderRadius = 'XL',
	fullWidth,
	className,
	loading,
	selected,
	checkbox,
	disabled,
	disabledInteraction,
	...props
}: ButtonBaseProps) => {
	return (
		<SmartElement
			className={cx(
				styledButton,
				`borderRadius${borderRadius}`,
				loading && 'loading',
				selected && 'selected',
				checkbox && 'checkbox-button',
				disabled && 'disabled',
				disabledInteraction && 'disabledInteraction',
				fullWidth && styledButtonBaseFullWidth,
				className
			)}
			disabled={disabled || loading}
			{...(props as SmartElementProps)}
		>
			{children}
			{loading && (
				<Loader className="loader">
					<LoaderIcon />
				</Loader>
			)}
		</SmartElement>
	);
};
